import { render } from "./ApartmentView.vue?vue&type=template&id=e04a48ca&scoped=true"
import script from "./ApartmentView.vue?vue&type=script&lang=js"
export * from "./ApartmentView.vue?vue&type=script&lang=js"

import "./ApartmentView.vue?vue&type=style&index=0&id=e04a48ca&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04a48ca"]])

export default __exports__